<template>
  <v-page-content>
    <content-info-page></content-info-page>
  </v-page-content>
</template>

<script>
import { mapMutations, mapActions } from 'vuex'

/* eslint-disable-next-line import/no-unresolved */
const ContentInfoPage = () => import('@/components/content/edit/EditContentInfo.vue')

export default {
  name: 'EditViewSingleEducation',
  components: {
    ContentInfoPage
  },
  beforeRouteUpdate(to, from, next) {
    this.getData(to.params.id)
    next()
  },
  created() {
    this.getData(this.$route.params.id)
  },
  methods: {
    ...mapActions({
      fetchSelectedContent: 'content/fetchSelectedContent'
    }),
    ...mapMutations({
      setContentType: 'content/setContentType'
    }),
    getData(id) {
      this.fetchSelectedContent(id).then(() => {
        if (this.$route.path.includes('course')) {
          this.setContentType('course')
        } else if (this.$route.path.includes('training')) {
          this.setContentType('training')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
